import { template as template_c4ab462499634b38b4964d1b86b695a8 } from "@ember/template-compiler";
import { serviceHelper as service } from 'eflex/helpers';
import { filter, pipe, collectBy, sortBy, map } from 'ramda';
import { sortByPaths } from 'ramda-adjunct';
import PowerSelect from 'eflex/components/power-select';
import { t } from 'ember-intl';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
const SelectedOption = template_c4ab462499634b38b4964d1b86b695a8(`
<span class="ember-power-select-selected-item d-inline" ...attributes>
  {{@option.name}}
</span>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const matcher = (item, term)=>{
    const pattern = new RegExp(`${term}`, 'i');
    if (pattern.test(item.name) || pattern.test(item.area?.name)) {
        return 1;
    } else {
        return -1;
    }
};
const getOptions = (stations, user, stationFilter)=>{
    if (user.role === 'User') {
        stations = stations.filter((station)=>{
            return user.hasConfigAuthorization(station.configEditorTags ?? []) || user.hasAuthorization(station.jemAuthorizedTags ?? []);
        });
    }
    if (stationFilter != null) {
        stations = stations.filter((item)=>item[stationFilter]);
    }
    return pipe(filter((station)=>!station.kineticDeleted), collectBy((station)=>station.area?.id), sortBy((areaStations)=>areaStations[0].area?.order), map((areaStations)=>({
            groupName: areaStations[0].area?.name,
            options: pipe(sortByPaths([
                [
                    'group',
                    'order'
                ],
                [
                    'order'
                ]
            ]), filter((station)=>{
                return !station.hideFromOperator || user.hasConfigAuthorization(station.configEditorTags ?? []);
            }))(areaStations)
        })))(stations);
};
export default class JemStationDropdown extends Component {
    @tracked
    isOpen = false;
    handleOpen = ()=>{
        this.isOpen = true;
    };
    handleClose = ()=>{
        this.isOpen = false;
    };
    static{
        template_c4ab462499634b38b4964d1b86b695a8(`
    <div class="jem-station-dropdown no-chrome-power-select d-flex align-items-center col-auto position-relative me-2">
      {{#let
        (service 'currentUser')
        (service 'stationRepo')
      as |currentUser stationRepo|}}
        <PowerSelect
          @dropdownClass="jem-station-dropdown {{@dropdownClass}}"
          @triggerClass="
            station-dropdown
            bg-transparent
            form-control
            form-control-lg
            border-0
            shadow-none
            fw-bold
            d-flex
            align-items-center
            p-0
            pointer
          "
          @onChange={{@onChange}}
          @options={{getOptions stationRepo.stations currentUser.user @filter}}
          @selected={{@selected}}
          @placeholder={{t "tree.selectLocation"}}
          @selectedItemComponent={{SelectedOption}}
          @searchEnabled={{true}}
          @searchPlaceholder={{t "search"}}
          @matcher={{matcher}}
          @onOpen={{this.handleOpen}}
          @onClose={{this.handleClose}}
          ...attributes
        as |opt|>
          <div class="tree-item {{opt.type}}">
            <span>
              {{opt.name}}
            </span>
          </div>
        </PowerSelect>
      {{/let}}
      <div class="position-absolute w-100 d-flex pe-none">
        <FaIcon
          @icon="caret-{{if this.isOpen "up" "down"}}"
          @prefix="fas"
          @size="lg"
          class="text-white ms-auto me-1"
        />
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
